import { z } from 'zod';

const HistoricalRateSchema = z.object({
    value: z.number(),
    date: z.string().optional().nullable(),
    mileage: z.number().optional().nullable(),
    fuelPerMile: z.number().optional().nullable(),
    fuelPerTrip: z.number().optional().nullable(),
});

export const GetHistoricalDataSchema = z.object({
    average: z.array(HistoricalRateSchema).nullable().optional(),
    high: z.array(HistoricalRateSchema).nullable().optional(),
    low: z.array(HistoricalRateSchema).nullable().optional(),
    loaded: z.boolean().optional().default(false),
    errored: z.boolean().optional().default(false),
    tripType: z.string().optional().nullable(),
    mileFuel: z.number().optional().default(0),
    tripFuel: z.number().optional().default(0),
    shortHaul: z.boolean().optional().default(false),
    fuelType: z.enum(['DAILY', 'CUSTOM', 'NONE']).optional().default('DAILY'),
    perLoad: z.boolean().optional().default(false),
    rateType: z.string().optional().nullable(),
    pageRateType: z.string().optional().nullable(),
    escalation: z.string().optional().nullable(),
});
export type Rate = z.infer<typeof HistoricalRateSchema>;
export type GetHistoricalData = z.infer<typeof GetHistoricalDataSchema>;
